@let isMobile = breakpoints() === "mobile";
<section class="gallery-layout gallery-layout-4">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-lg-6">
        @if (subtitle()) {
          <app-title [titles]="[subtitle()]" />
        }
        @if (title()) {
          <app-title [titles]="[title()]" class="title" />
        }
      </div>
      @if (!isMobile && data().items.length > 3) {
        <div class="col-lg-12">
          <div class="list-controls">
            <i
              (click)="onPrev(data().items.length / 3)"
              [color]="'GREY_LIGHT'"
              [iconName]="'ARROW_BIG_LEFT'"
              [size]="'3.2rem'"
              class="list-controls-left"></i>
            <i
              (click)="onNext(data().items.length / 3)"
              [color]="'GREY_LIGHT'"
              [iconName]="'ARROW_BIG_RIGHT'"
              [size]="'3.2rem'"
              class="list-controls-right"></i>
          </div>
        </div>
      }
      <div class="col-xs-12 col-lg-12">
        <ul #listElement class="list">
          @for (item of data().items; track item) {
            <li class="list-item">
              <figure class="figure">
                @if (item.image; as image) {
                  <app-image
                    (click)="onSelect(item)"
                    [image]="image"
                    [size]="{ dw: 384, dh: 480, mw: 157, mh: 196 }"
                    class="img" />
                }
                @if (item.fullname || item.job) {
                  <figcaption>
                    <hr class="separator" />
                    @if (item.fullname; as name) {
                      <span [innerHTML]="name" class="name"></span>
                    }
                    @if (item.job; as job) {
                      <span [innerHTML]="job" class="job"></span>
                    }
                  </figcaption>
                }
              </figure>
              @if (!isMobile) {
                <div [class.description--open]="selectedItem() === item" class="description">
                  <i
                    (click)="selectedItem.set(null!)"
                    [color]="'BLACK'"
                    [iconName]="'CLOSE'"
                    [size]="'2rem'"
                    class="icon"></i>
                  @if (selectedItem()) {
                    <span class="description--text">{{ selectedItem().text }}</span>
                  }
                </div>
              }
            </li>
          }
        </ul>
      </div>
      @if (isMobile) {
        <div class="col-xs-12 col-lg-12">
          <div [class.description--open]="!!selectedItem()" class="description">
            <i
              (click)="selectedItem.set(null!)"
              [color]="'BLACK'"
              [iconName]="'CLOSE'"
              [size]="'2rem'"
              class="icon"></i>
            @if (selectedItem()) {
              <span class="description--text">{{ selectedItem().text }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</section>
